export default "__VITE_PUBLIC_ASSET__78c0b93a__"